import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const BewerbungCTA = () => {
  return (
    <section className="py-24 md:py-32 bg-foreground text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background:
            'radial-gradient(ellipse at 80% 10%, hsl(227 78% 52% / 0.35) 0%, transparent 55%), radial-gradient(ellipse at 10% 90%, hsl(227 70% 34% / 0.45) 0%, transparent 60%)',
        }}
      />
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto text-center"
        >
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary font-semibold mb-4">Jetzt bewerben</p>
          <h2 className="font-normal text-white mb-6">
            Zwei Minuten, <span className="italic text-primary">ein Anfang.</span>
          </h2>
          <p className="text-lg md:text-xl text-white/70 leading-relaxed mb-10">
            Kein Anschreiben, kein Lebenslauf. Nur ein paar Angaben zu dir und wir melden uns innerhalb von 48 Stunden.
          </p>
          <Link
            to="/bewerben"
            className="group inline-flex items-center bg-primary text-primary-foreground hover:bg-primary/90 font-semibold text-base px-8 py-4 rounded-xl transition-all duration-300 hover:scale-[1.03] shadow-[0_10px_40px_hsl(227_78%_52%/0.35)]"
          >
            Bewerbung starten
            <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
          </Link>
          <p className="text-sm text-white/50 mt-8">
            Lieber telefonisch? <a href="tel:+4915901981213" className="text-primary hover:underline">+49 (1590) 1981213</a> oder per E-Mail an <a href="mailto:klemens.von-rosen@horbach.de" className="text-primary hover:underline">klemens.von-rosen@horbach.de</a>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BewerbungCTA;
